@if (artifacts.activeArtifact(); as _artifact) {
	<ng-container *ngComponentOutlet="_artifact.responseType | adaLlmArtifactRendererType; inputs: { artifact: _artifact }" />
} @else {
	<div class="ada-container ada-full-height ada-flex-center">
		<div>
			<ada-alert
				data-testid="ada-llm-artifact-renderer-empty-alert"
				details="Continue chatting with {{ aida.displayName() }} to generate viewable artifacts"
				title="No artifact to show"
				[isClosable]="false"
			/>
			<div
				class="ada-text-align-center"
				[style.margin-top]="ui.Spacing.SPACING_LARGE"
			>
				<button
					aria-label="Close"
					class="ada-btn ada-btn-no-margin"
					title="Close"
					(click)="artifacts.isOpen.set(false)"
				>
					Close
				</button>
			</div>
		</div>
	</div>
}
